import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const ReviewList = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const UPDATE_REVIEW_API =
    "https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_review";


  // Fetch reviews from API
  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await fetch(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_review"
        );

        if (!response.ok) {
          throw new Error("Failed to fetch reviews");
        }

        const result = await response.json();

        // ✅ FIX: use `status` instead of `success`
        if (result.status && Array.isArray(result.data)) {
          const mappedReviews = result.data.map((item) => ({
            id: item.id,
            name: `User #${item.user_id}`, // API does not send name
            avatar: item.image?.length
              ? `https://cyberathon.com/multivendor/${item.image[0]}`
              : "/images/users/default-avatar.jpg",
            product: item.product_name,
            rating: Number(item.rating) || 0,
            review: item.your_review,
            status: item.status, // approve | reject  // API does not provide status
          }));

          setReviews(mappedReviews);
        } else {
          setError("Invalid data format from server");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchReviews();
  }, []);

  const deleteReview = async (id) => {
  if (!window.confirm("Are you sure you want to delete this review?")) return;

  try {
    const response = await axios.post(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/delete_review",
      { id },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const result = response.data;

    if (result.status === "true" || result.status === true) {
      toast.error("Review deleted successfully!");
      setReviews((prev) => prev.filter((item) => item.id !== id));
    } else {
      toast.error(result.message || "Delete failed");
    }
  } catch (err) {
    console.error("Delete error:", err.response || err);
    toast.error("Something went wrong while deleting review");
  }
};



  const updateReviewStatus = async (review, newStatus) => {
    try {
      const formData = new FormData();
      formData.append("id", review.id);
      formData.append("user_id", review.user_id);
      formData.append("seller_id", review.seller_id);
      formData.append("rating", review.rating);
      formData.append("your_review", review.review);
      formData.append("product_name", review.product);
      formData.append("status", newStatus);
      formData.append("created_at", review.created_at);

      const response = await fetch(UPDATE_REVIEW_API, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (result.status === "true" || result.status === true) {
        setReviews((prev) =>
          prev.map((r) =>
            r.id === review.id ? { ...r, status: newStatus } : r
          )
        );
        toast.success(`Review ${newStatus} successfully`);
      } else {
        toast.error(result.message || "Update failed");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    }
  };






  const renderStars = (count) => {
    return (
      <span>
        {[...Array(count)].map((_, i) => (
          <i key={i} className="fa-solid fa-star text-warning me-1"></i>
        ))}
        {[...Array(5 - count)].map((_, i) => (
          <i key={i} className="fa-regular fa-star text-muted me-1"></i>
        ))}
      </span>
    );
  };

  if (loading) {
    return (
      <div className="page-content">
        <div className="container-fluid">
          <div className="text-center mt-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2">Loading reviews...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-content">
        <div className="container-fluid">
          <div className="alert alert-danger mt-4" role="alert">
            Error: {error}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Customer Reviews</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Product Management</a>
                </li>
                <li className="breadcrumb-item active">Review List</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h4 className="card-title mb-0">All Reviews</h4>
                <a href="#!" className="btn btn-outline-light btn-sm rounded">
                  Export Reviews
                </a>
              </div>
              <div className="card-body p-0">
                {reviews.length === 0 ? (
                  <div className="text-center py-4">No reviews found.</div>
                ) : (
                  <div className="table-responsive">
                    <table className="table align-middle table-hover mb-0 table-centered">
                      <thead className="bg-light-subtle">
                        <tr>
                          <th>#</th>
                          <th>Reviewer</th>
                          <th>Product</th>
                          <th>Rating</th>
                          <th>Review</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {reviews.map((review, index) => (
                          <tr key={review.id}>
                            <td>{index + 1}</td>
                            <td>
                              {/* <img
                                src={review.avatar}
                                alt="avatar"
                                className="avatar-xs rounded-circle me-2"
                                onError={(e) => {
                                  e.target.src = "/images/users/default-avatar.jpg";
                                }}
                              /> */}
                              {review.name}
                            </td>
                            <td>{review.product}</td>
                            <td>{renderStars(review.rating)}</td>
                            <td>{review.review}</td>
                            <td>
                              <span
                                className={`badge px-2 py-1 ${review.status === "approve"
                                  ? "bg-success-subtle text-success"
                                  : "bg-danger-subtle text-danger"
                                  }`}
                              >
                                {review.status === "approve" ? "Approved" : "Rejected"}
                              </span>
                            </td>
                            <td>
                              <div className="d-flex gap-2">

                                <span
                                  className="btn btn-soft-danger btn-sm"
                                  title="Delete"
                                  onClick={() => deleteReview(review.id)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <i className="fa-solid fa-trash"></i>
                                </span>


                                <button
                                  className="btn btn-success btn-sm"
                                  disabled={review.status === "approve"}
                                  onClick={() => updateReviewStatus(review, "approve")}
                                >
                                  <i className="fa-solid fa-check"></i>
                                </button>

                                <button
                                  className="btn btn-warning btn-sm"
                                  disabled={review.status === "reject"}
                                  onClick={() => updateReviewStatus(review, "reject")}
                                >
                                  <i className="fa-solid fa-xmark"></i>
                                </button>

                              </div>
                            </td>

                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              <div className="card-footer border-top text-end">
                <small className="text-muted">
                  Showing {reviews.length} of {reviews.length} reviews
                </small>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="footer">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 text-center">
                © Venton. Crafted by{" "}
                <iconify-icon
                  icon="iconamoon:heart-duotone"
                  className="fs-18 align-middle text-danger"
                />{" "}
                <a href="#" className="fw-bold footer-text" target="_blank" rel="noopener noreferrer">
                  Techzaa
                </a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default ReviewList;